import React from 'react';

const RichTextEditor = ({ value, onChange, label, placeholder, rows = 10 }) => {
  return (
    <div className="space-y-2">
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <textarea
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0F388E] focus:border-transparent resize-vertical"
        dir="auto"
      />
    </div>
  );
};

export default RichTextEditor;
